(ns practitest.frontend.components.lists
  (:require ["react-select" :default Select]
            [goog.object :as gobj]))

(defn objects-list [{:keys [clearable?
                            disabled?
                            autofocus?
                            multi?
                            field-id
                            options
                            value
                            components
                            class

                            menu-portal-target
                            open-menu-on-focus?

                            label-fn
                            value-fn

                            on-change
                            on-blur]
                     :as   props}]
  [:r> Select #js {:classNamePrefix  "pt-select"
                   :className        class
                   :id               (when field-id (name field-id))

                   :isClearable      (boolean clearable?)
                   :isDisabled       (boolean disabled?)
                   :autoFocus        (boolean autofocus?)
                   :isMulti          (boolean multi?)

                   :components       components

                   :getOptionLabel   (fn [object]
                                       (label-fn object))
                   :getOptionValue   (fn [object]
                                       (value-fn object))

                   :maxMenuHeight    200
                   :isOptionSelected (fn [option selectValue]
                                       (when-let [object (first selectValue)]
                                         (= object option)))

                   ;:menuIsOpen       true
                   :menuPortalTarget menu-portal-target
                   :openMenuOnFocus  (boolean open-menu-on-focus?)

                   ;; Theme and styles customisation
                   ;; TODO: keep consistent with SCSS
                   :theme            (fn [theme]
                                       ;; Bootstrap Primary color
                                       (gobj/set (.-colors theme) "primary" "#337ab7")
                                       ;; TODO: change primary75/50/25 as well
                                       theme)
                   :styles           #js {:control (fn [provided state]
                                                     ;(js/console.log "state" state)

                                                     (let [focused? (.-isFocused state)]
                                                       (if focused?
                                                         (do
                                                           ;; Make outline consistent with Bootstrap styled component
                                                           ;; TODO: keep consistent with SCSS colors
                                                           (gobj/set provided "boxShadow" "0 0 0 0.25rem rgba(51, 122, 183, 0.25)")
                                                           provided)
                                                         provided)))
                                          :menu    (fn [provided state]
                                                     ;; Override z-index to fix footer overlap
                                                     (gobj/set provided "zIndex" "10")
                                                     provided)}

                   ;; Pass options as JS array of CLJS objects
                   :options          (apply array options)

                   ;; Multi-option select should use array of objects as value
                   :value            (if multi?
                                       (apply array value)
                                       value)

                   :onChange         (fn [object _]
                                       (when on-change
                                         (on-change object)))
                   :onBlur           (fn [e]
                                       (when on-blur
                                         (on-blur e)))}])

(defn simple-list [{:keys [options
                           value
                           on-change]
                    :as   props}]
  [objects-list (assoc props
                  :label-fn :label
                  :value-fn :value
                  :options  (for [o options]
                              {:label o :value o})

                  :value    {:value value
                             :label value}

                  :on-change (fn [raw]
                               (when on-change
                                 (on-change (:value raw)))))])
